export default {"src":"/_next/static/media/money-wings-slateus.2a18292c.svg","height":100,"width":100};